import BookItem from "../common/bookItem";
// import { mouseEvent } from "../common/mouse_event";
export default class ControlAniStatePic extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
    }

    init() {
        this.target.mouseEnabled = false;
        this.target.gotoAndStop(0);
        this.target.loop = 0;
    }

    trigger() {

    }
}